module.exports = __webpack_public_path__ + "static/media/mood.ec82e694.png";